import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AboutGalleryAdmin({ gallery, setGallery }) {
  const [uploading, setUploading] = useState(0);

  const upload = async (files) => {
    setUploading(files.length);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/admin/about/gallery", fd);
        setGallery((g) => [...g, data]);
      } catch (e) { toast.error(`${file.name}: ${e?.response?.data?.detail || "no se pudo subir"}`); }
      setUploading((n) => n - 1);
    }
    toast.success("Galería actualizada ✦");
  };

  const remove = async (id) => {
    if (!window.confirm("¿Quitar esta foto de la galería?")) return;
    try {
      await api.delete(`/admin/about/gallery/${id}`);
      setGallery((g) => g.filter((x) => x.id !== id));
    } catch { toast.error("No se pudo quitar la foto"); }
  };

  return (
    <div data-testid="about-gallery-admin" className="md:col-span-2 border-t border-white/5 pt-10">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <p className="overline mb-1">Galería</p>
          <p className="text-zinc-500 text-sm">Fotos de tu espacio y tus sesiones. Se muestran debajo del texto.</p>
        </div>
        <label className="btn-ghost inline-block cursor-pointer text-sm">
          {uploading > 0 ? `Subiendo… (${uploading})` : "+ Añadir fotos"}
          <input type="file" accept="image/*" multiple data-testid="about-gallery-upload" className="hidden"
            disabled={uploading > 0}
            onChange={(e) => { const f = [...(e.target.files || [])]; if (f.length) upload(f); e.target.value = ""; }} />
        </label>
      </div>
      {gallery.length === 0 ? (
        <p className="text-zinc-600 text-sm italic">Aún no hay fotos en la galería.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {gallery.map((g) => (
            <div key={g.id} data-testid={`about-gallery-item-${g.id}`} className="relative group">
              <img src={`${BACKEND_URL}${g.url}`} alt="" className="w-full aspect-square object-cover border border-white/10" />
              <button onClick={() => remove(g.id)} data-testid={`about-gallery-remove-${g.id}`}
                className="absolute top-2 right-2 bg-black/70 text-xs text-zinc-200 hover:text-red-400 px-2 py-1">
                Quitar
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
